import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import SetupPage from './pages/SetupPage';
import DataManagementPage from './pages/DataManagementPage';
import AppShell from './pages/AppShell';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import SettingsPage from './pages/SettingsPage';
import ImportPage from './pages/ImportPage';
import StockAnalysisPage from './pages/StockAnalysisPage';
import OrderAnalysisPage from './pages/OrderAnalysisPage';
import DesignNeedPage from './pages/DesignNeedPage';
import DispatchAnalysisPage from './pages/DispatchAnalysisPage';
import ProductionPlanningPage from './pages/ProductionPlanningPage';
import PriceListPage from './pages/PriceListPage';
import InactiveCustomersPage from './pages/InactiveCustomersPage';
import RefPartyMonthPage from './pages/RefPartyMonthPage';
import CustomersDispatchedPage from './pages/CustomersDispatchedPage';
import ActiveCustomersPage from './pages/ActiveCustomersPage';
import GrowthPage from './pages/GrowthPage';
import LoginActivityPage from './pages/LoginActivityPage';
import ComplaintsPage from './pages/ComplaintsPage';
import DemandSensingPage from './pages/DemandSensingPage';
import ForecastingPage from './pages/ForecastingPage';
import RecommendationsPage from './pages/RecommendationsPage';
import OptimizationPage from './pages/OptimizationPage';
import ClassificationPage from './pages/ClassificationPage';
import AnalyticsPage from './pages/AnalyticsPage';
import ExecutiveSummaryPage from './pages/ExecutiveSummaryPage';
import ReportsPage from './pages/ReportsPage';
import PlatformAdminLoginPage from './pages/PlatformAdminLoginPage';
import PlatformAdminDashboardPage from './pages/PlatformAdminDashboardPage';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/setup" element={<SetupPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="stock-analysis" element={<StockAnalysisPage />} />
            <Route path="order-analysis" element={<OrderAnalysisPage />} />
            <Route path="order-analysis/design-need" element={<DesignNeedPage />} />
            <Route path="dispatch-analysis" element={<DispatchAnalysisPage />} />
            <Route path="production-planning" element={<ProductionPlanningPage />} />
            <Route path="price-list" element={<PriceListPage />} />
            <Route path="inactive-customers" element={<InactiveCustomersPage />} />
            <Route path="ref-party-month" element={<RefPartyMonthPage />} />
            <Route path="customers-dispatched" element={<CustomersDispatchedPage />} />
            <Route path="active-customers" element={<ActiveCustomersPage />} />
            <Route path="growth" element={<GrowthPage />} />
            <Route path="login-activity" element={<LoginActivityPage />} />
            <Route path="complaints" element={<ComplaintsPage />} />
            <Route path="demand-sensing" element={<DemandSensingPage />} />
            <Route path="forecasting" element={<ForecastingPage />} />
            <Route path="recommendations" element={<RecommendationsPage />} />
            <Route path="optimization" element={<OptimizationPage />} />
            <Route path="classification" element={<ClassificationPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="executive-summary" element={<ExecutiveSummaryPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="imports/:type" element={<ImportPage />} />
            <Route path="data-management" element={<DataManagementPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="/platform-admin/login" element={<PlatformAdminLoginPage />} />
          <Route path="/platform-admin" element={<PlatformAdminDashboardPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
